import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

const RootRedirect: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />;
  }

  // If authenticated, redirect based on user role
  switch (user.role) {
    case 'ADMIN':
      return <Navigate to="/admin/platform-overview" replace />;
    case 'TEACHER':
      return <Navigate to="/teacher/overview" replace />;
    default:
      // For any other role (like STUDENT), redirect to login
      return <Navigate to="/auth/login" replace />;
  }
};

export default RootRedirect;